






import { Vue } from "vue-property-decorator";
import router from "@/router";

import "vue-material-design-icons/styles.css";

import VueMarkdownEditor from "@kangc/v-md-editor";
import enUS from "@kangc/v-md-editor/lib/lang/en-US";
import "@kangc/v-md-editor/lib/style/base-editor.css";
import vuepressTheme from "@kangc/v-md-editor/lib/theme/vuepress.js";

import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

import GithubUserService from "@/services/GithubUserService";

VueMarkdownEditor.use(vuepressTheme);
VueMarkdownEditor.lang.use("en-US", enUS);
Vue.use(VueMarkdownEditor);

Vue.use(Toast, {
  timeout: 3000,
  transition: "Vue-Toastification__fade",
  pauseOnFocusLoss: false
});

function checkTokenValidity() {
  const token = localStorage.getItem("token");
  if (!token) {
    return;
  }
  return GithubUserService.get(token).catch(err => {
    if (err.response.status == 401) {
      localStorage.removeItem("token");
      Vue.$toast.error("Could not authenticate");
    }
    router.push({ name: "login" });
    return;
  });
}
checkTokenValidity();

export default {};
